import React, { FC } from 'react';
import { ConfirmDialog } from '@beeline.com/bp-design-system';
import { useStaticGlobalIntl } from 'utils/intl/useStaticGlobalIntl';
import { useDeleteGenders } from '../hooks/useDeleteGenders';
import { useGenderIntl } from '../translations/useGenderIntl';

interface Props {
  open: boolean;
  onClose(): void;
  uids: string[];
  onDone: (uids: string[]) => void;
}

const DeleteGendersModal: FC<React.PropsWithChildren<Props>> = ({ open, onClose, onDone, uids }) => {
  const { deleteSelected, loading } = useDeleteGenders();
  const [deleteLabel, cancelLabel] = useStaticGlobalIntl('general.Delete', 'general.Cancel');
  const { deleteDescription, confirmDelete } = useGenderIntl();

  const submitForm = async () => {
    if (uids) {
      try {
        await deleteSelected(uids);
        onDone(uids);
      } catch {}
    }
  };

  return (
    <ConfirmDialog
      title={confirmDelete({ total: uids.length })}
      open={open}
      onSubmit={submitForm}
      onClose={onClose}
      loading={loading}
      slotProps={{
        submitButton: { children: deleteLabel, error: true },
        cancelButton: { children: cancelLabel }
      }}
      dataTest="delete_reasons"
      subTitle={deleteDescription({ total: uids.length })}
    />
  );
};

export default DeleteGendersModal;
